import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {
    accountSearchResultCrmIntegrationDataSelector,
    accountSearchResultCrmIntegrationResultSelector,
} from '../../slices/account-search-result-crm-integration.slice';

type Props = {
    accountId: number,
};

export const DealCLoudIntegrationCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultCrmIntegrationDataSelector);
    const result = useSelector(accountSearchResultCrmIntegrationResultSelector);

    const dealCloudEnabled = useMemo(() => {
        if (!result?.data[accountId]) {
            return undefined;
        } else {
            return result?.data[accountId].dealCloudEnabled ? 'Yes' : 'No';
        }
    }, [result, accountId]);

    if (isLoading || loadingError || !dealCloudEnabled) {
        return null;
    }

    return (
        <span>{dealCloudEnabled}</span>
    );
};
